import { defaultFetchServiceOverride } from "app/pages/activation";

import { benchmarkApiService } from "./api/benchmark";
import { metricApiService } from "./api/metric";
import { reportApiService } from "./api/report";
export { BENCHMARKS_ENDPOINT, BENCHMARK_USER_API } from "./api/constants";

export const createBenchmarkTrackerApi = () => {
    return {
        benchmark: benchmarkApiService(defaultFetchServiceOverride),
        metric: metricApiService(defaultFetchServiceOverride),
        report: reportApiService(defaultFetchServiceOverride),
    };
};
